import ReactDOM from 'react-dom';

/**
 * IMPORTANT: This method is a temporal utility to help in the migration from
 * React v16 to v18. It should be removed after the migration is completed.
 *
 * Render a component using the correct react-dom APIs dependending
 * on the ReactDOM version available in the context of execution.
 *
 * @param {Object} component React node to be rendered.
 * @param {Object} DOMEl DOM Element
 * @return {Object} ReactDOM rendered component
 */
export const renderUsingContextVersion = (component, DOMEl) => {
  // @ts-expect-error Disabling for migration purposes
  const isReactDomV18 = typeof ReactDOM.createRoot === 'function';

  return isReactDomV18
    // @ts-expect-error Disabling for migration purposes
    ? ReactDOM.createRoot(DOMEl).render(component)
    // eslint-disable-next-line react/no-deprecated
    : ReactDOM.render(component, DOMEl);
};
